import React from 'react';
import { connect } from 'react-redux';
import { showModalMessage } from '../store/modalsSlice';
import * as productReleaseHist from '../store/objectHistorySlice';
import { objectHistoryNames, objectHistorySelectors } from '../store/objectHistorySlice';
import EditingDataHistoryDialog from '../components/editingDataHistoryDialog';
import ProductReleaseHistoryTable from '../components/productReleaseHistoryTable';

class ProductReleaseHistoryDialog extends EditingDataHistoryDialog {
  get dataId() {
    return this.props.id;
  }

  get Title() {
    return "Product release history";
  }

  renderTable(tableProps) {
    return <ProductReleaseHistoryTable {...tableProps}/>
  }

  renderBeforeContent() {
    return `Product release: ${this.props.productName} v${this.props.productVersion}`;
  }

  getLoaderMessage() {
    return "Product release history loading..."
  }
}

const mapStateToProps = (state) => ({
  objectState: objectHistorySelectors.productReleases(state)
});

const actionCreators = {
  fetchHistory: (id) => productReleaseHist.fetchHistory(id, objectHistoryNames.productReleases),
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(ProductReleaseHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/productReleaseHistoryDialog.js